<template>
  <div class="coach-book-page" v-loading="bookLoading">
    <el-form :model="bookForm" ref="bookForm" label-position="top">

      <div class="leapin-air-title"><img :src="linkAir" />Topic</div>
      <div class="leapin-mb-20">
        <el-form-item>
          <el-select v-model="bookForm.coachType">
            <el-option
              v-for="(item,index) in coachCodeList"
              :key="index"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
        <!-- 时间选择 -->
        <div class="leapin-air-title"><img :src="linkAir" />Avaliable time</div>
        <el-select filterable v-model="selectedTimezone" @change="changeTimeZone" class="leapin-mb-20">
          <el-option
            v-for="(item,index) in timeZoneList"
            :key="index"
            :value="item">
            {{ item }}
          </el-option>
        </el-select>
        <div class="leapin-mb-20">
          <el-row :gutter="30">
            <el-col :span="18">
              <el-calendar>
                <template
                  slot="dateCell"
                  slot-scope="{ data }">
                  <p 
                    @click="handleClick(data.day)"
                    :class="[
                      haveDateList.includes(data.day) ? 'is-have-data' : '',
                      data.isSelected ? 'is-selected' : ''
                    ]">
                    {{ data.day.split('-').slice(1)[1] }}
                  </p>
                </template>
              </el-calendar>
            </el-col>
            <el-col :span="6">
              <div class="date-list">
                <div v-for="(e,i) in interviewListShow" :key="i" @click="chooseInterView(e,i)">
                  <div :class="['item',nowInterIndex == i ? 'active' : '']">
                    <div class="time">{{ e.time }}</div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div class="leapin-air-title"><img :src="linkAir" />Describe you question</div>
        <el-form-item prop="describe" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
          <el-input
            type="textarea"
            rows="5"
            placeholder="Please enter"
            v-model="bookForm.describe">
          </el-input>
        </el-form-item>
        
    </el-form>
    <div class="jfp-footer">
      <div class="leapin-short-defalut-button but" @click="Cancel">Cancel</div>
      <div class="leapin-short-primary-button but" @click="onSubmit">Confirm</div>
    </div>
  </div>
</template>

<script>
import { getUserInfo, getReserveInfo, getInfoByID, timezoneConvert,submitReserveInfo } from "@/services/user.js";
import { COACH_CODE }  from '@/constants/coachCode'
import { TIMEZONE_CODE } from '@/constants/timeZone'
export default {
  props: {
    coachId: {
      type: Number,
      default: 0
    }
  },
  name: 'CoachBook',
  data() {
    return {
      bookLoading: false,
      nowInterIndex: -1,
      nowInterObj: {},
      timeZoneList: TIMEZONE_CODE,
      selectedTimezone: 'UTC', // 默认时区
      dateValue: new Date(),
      haveDateList: [], // 有数据的日期
      interviewList: [], // 面试时间列表
      interviewListShow: [], // 面试时间列表 ---展示
      coachCodeList: COACH_CODE,
      linkAir: require('@/assets/svgs/link-air.svg'),
      bookForm: {
        coachType: 'Career coaching',
        describe: '',
      },
      booKRules: {
        coachType: [
          { required: true, message: 'Please select', trigger: 'change' }
        ]
      },
      coachInfo: {}, // 教练信息
    }
  },
  mounted () {
    this.getCoachInfo(); // 获取登陆人信息
  },
  methods: {
    // 时区改变
    changeTimeZone(timeZone) {
      this.selectedTimezone = timeZone;
      let parmas = {
        now_timezone: timeZone,
        to_timezone: this.coachInfo.extra_info.timezone,
        schedule: this.coachInfo.extra_info.schedule
      }
      timezoneConvert(parmas).then((res) => {
        if (res.code === 0) {
          this.interviewList = [];
          this.interviewListShow = [];
          this.haveDateList = [];
          res.data.forEach((item) => {
            this.haveDateList.push(item.start_time.substring(0,10));
            let obj = {
              date: item.start_time.substring(0,10),
              time: `${item.start_time.substring(11,16)} - ${item.end_time.substring(11,16)}`,
              orginTime: item
            }
            this.interviewList.push(obj);
          })
        } else {
          this.$message.error(res.message);
        }
      })
    },
    chooseInterView (item,index) {
      this.nowInterIndex = index;
      this.nowInterObj = item.orginTime;
      //alert(JSON.stringify(this.nowInterObj))
    },
    //获取登陆人信息
    getCoachInfo() {
      getInfoByID({},this.coachId).then((res) => {
        if (res.code === 0) {
          this.coachInfo = res.data;
          //alert(JSON.stringify(this.coachInfo.extra_info.schedule))
          this.coachInfo.extra_info.schedule.forEach((item) => {
            this.haveDateList.push(item.start_time.substring(0,10));
            let obj = {
              date: item.start_time.substring(0,10),
              time: `${item.start_time.substring(11,16)} - ${item.end_time.substring(11,16)}`,
              orginTime: item
            }
            this.interviewList.push(obj);
          })
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 点击日期
    handleClick(day) {
      this.interviewListShow= [];
      this.interviewListShow = this.interviewList.filter((item) => {
        return item.date === day;
      })
    },
    // 提交
    onSubmit() {
      if (JSON.stringify(this.nowInterObj) == '{}') {
        this.$message.warning('Please select the time');
        return;
      }
      this.bookLoading = true;
      this.$refs.bookForm.validate((valid) => {
        if (valid) {
          let params = {
            coach_id: this.coachId,
            topic: this.bookForm.coachType,
            question_desc: this.bookForm.describe,
            timezone: this.selectedTimezone,
            reserve_time: this.nowInterObj,
          }
          //console.log(JSON.stringify(params))
          submitReserveInfo(params).then((res) => {
            this.bookLoading = false;
            if (res.code === 0) {
              this.$message.success('Booking success');
              this.$emit('closeBook');
            } else {
              this.$message.error(res.message);
            }
          })
        } else {
          this.bookLoading = false;
          return false;
        }
      });
    },

    // 取消
    Cancel() {
      this.$emit('closeBook');
    },

  }
}
</script>
<style scoped lang="scss">
.coach-book-page {
  padding: 20px;
  position: relative;
  overflow-x: hidden;
  overflow-y: scroll;
  margin-bottom: 50px;
  .date-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    overflow-x: hidden;
    overflow-y: scroll;
    font-family: "PingFang SC";
    height: 450px;
    .active {
      background: #e9e8fa !important;
      color: #fff !important;
    }
    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 12px;
      background: #fff;
      padding: 8px 20px;
      border: 1px solid #6E62E5;
      cursor: pointer;
      width: fit-content;
      .time {
        color: #6E62E5;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        align-items: center;
        gap: 0 4px;
      }
    }
  }
  .jfp-footer {
    width: -webkit-fill-available;
    position: fixed;
    z-index: 9;
    bottom: 0;
    padding: 20px 20px 20px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0 20px;
    background: #fff;
    .but {
      padding: 4px 16px !important;
    }
  }
  .is-have-data {
    background: #e9e8fa;
    color: #fff;
    width: 50px;
    height: 43px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .is-selected {
    background: #6E62E5;
    color: #fff;
    width: 50px;
    height: 43px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
<style lang="scss">
.coach-book-page {
  .el-calendar-table td.is-selected {
    background: none !important;
  }
  .el-calendar-table .el-calendar-day:hover {
    background: none !important;
  }
  .el-calendar {
    border: 1px solid #E5E9F2;
  }
  .el-calendar-table .el-calendar-day {
    height: 60px !important;
    width: 60px !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .el-calendar__body {
    padding: 12px 20px 0px;
  }
  .el-calendar-table td {
    border: none;
  }
  .el-table tr {
    border-radius: 12px;
    background: #F8F9FB;
  }
  .el-table .el-table__cell {
    gap: 10px 0;
  }
  .el-calendar__button-group .el-button-group .el-button--mini:first-child {
    display: none;
  }
  .el-calendar-table thead th {
    padding-left: 27px;
  }
}
</style>
